import { AlertActionEnum } from '@common/enums/alert-action.enum';
import { ROUTE_PATHS } from '@common/utils/route-paths.const';

/**
 * Maps an alert action key to its concrete route segments.
 *
 * Pure helper shared by both the onboarding flow (AlertsService) and the
 * investment-access popup gate (InvestmentAccessService) so the two never
 * diverge. `hasNationalId` decides the nafath sub-route (update vs initiate).
 */
export function actionKeyToRoute(
  key: AlertActionEnum,
  hasNationalId: boolean
): string[] {
  switch (key) {
    case AlertActionEnum.SUBMIT_NAFATH:
      return hasNationalId
        ? [ROUTE_PATHS.NAFATH, ROUTE_PATHS.UPDATE]
        : [ROUTE_PATHS.NAFATH, ROUTE_PATHS.INITIATE];
    case AlertActionEnum.SUBMIT_KYC:
    case AlertActionEnum.RENEW_KYC:
      return [ROUTE_PATHS.KYC];
    case AlertActionEnum.ADD_BANK_ACCOUNT:
      return [
        ROUTE_PATHS.ACCOUNT,
        ROUTE_PATHS.BANK_ACCOUNT,
        ROUTE_PATHS.UPDATE,
      ];
    case AlertActionEnum.SUBMIT_WAKALA:
      return [ROUTE_PATHS.WAKALA];
    default:
      return [ROUTE_PATHS.HOME];
  }
}
